'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdHttps = function MdHttps(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25.2 13.4v-3.4q0-2.1-1.6-3.6t-3.6-1.6-3.6 1.6-1.6 3.6v3.4h10.4z m-5.2 15q1.3 0 2.3-1.1t1.1-2.3-1.1-2.3-2.3-1.1-2.3 1.1-1.1 2.3 1.1 2.3 2.3 1.1z m10-15q1.3 0 2.3 0.9t1.1 2.3v16.8q0 1.3-1.1 2.3t-2.3 0.9h-20q-1.3 0-2.3-0.9t-1.1-2.3v-16.8q0-1.3 1.1-2.3t2.3-0.9h1.6v-3.4q0-3.4 2.5-5.9t5.9-2.5 5.9 2.5 2.5 5.9v3.4h1.6z' })
        )
    );
};

exports.default = MdHttps;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/https.js
// module id = 1617
// module chunks = 168707334958949